import { CSSProperties, KeyboardEvent } from 'react';

type ProficiencyToggleProps = {
    value: number;
    disabled?: boolean;
    ariaLabel?: string;
    onChange: (value: number) => void;
    style?: CSSProperties;
};

function ProficiencyToggle({
    value,
    disabled = false,
    ariaLabel = 'Proficiency',
    onChange,
    style = {},
}: ProficiencyToggleProps) {
    const advance = () => {
        if (!disabled) onChange((value + 1) % 3);
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            advance();
        }
    };

    return (
        <button
            type="button"
            aria-label={ariaLabel}
            aria-pressed={value !== 0}
            title={value === 0 ? 'Not proficient' : value === 1 ? 'Proficient' : 'Expertise'}
            disabled={disabled}
            onClick={advance}
            onKeyDown={handleKeyDown}
            style={{
                position: 'relative',
                display: 'inline-grid',
                placeItems: 'center',
                width: '1.15em',
                height: '1.15em',
                flex: '0 0 auto',
                boxSizing: 'border-box',
                padding: 0,
                border: '0.11em solid currentColor',
                borderRadius: '50%',
                color: disabled ? '#9a9a98' : 'inherit',
                background: value === 0 ? '#ffffff' : 'currentColor',
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.6 : 1,
                appearance: 'none', ...style,
            }}
        >
            {value === 2 && (
                <span
                    aria-hidden="true"
                    style={{
                        width: '.48em',
                        height: '.48em',
                        boxSizing: 'border-box',
                        borderRadius: '50%',
                        background: '#ffffff',
                    }}
                />
            )}
        </button>
    );
}

export default ProficiencyToggle;
